module.exports = __webpack_public_path__ + "static/img/product_images_29_h5_zh.b3ee471.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_images_29_h5_zh.png
// module id = fTq1
// module chunks = 34